import { render, staticRenderFns } from "./NoInfoHeaderLayout.vue?vue&type=template&id=21eef2c8&"
import script from "./NoInfoHeaderLayout.vue?vue&type=script&lang=js&"
export * from "./NoInfoHeaderLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports